export const ACCOUNTING_PERIODS_PATH = '/accounting-periods';
